import { render, staticRenderFns } from "./GroupResponsible.vue?vue&type=template&id=37f7e876&scoped=true"
import script from "./GroupResponsible.vue?vue&type=script&lang=js"
export * from "./GroupResponsible.vue?vue&type=script&lang=js"
import style0 from "./GroupResponsible.vue?vue&type=style&index=0&id=37f7e876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f7e876",
  null
  
)

export default component.exports